// Lightweight tracking layer — emits events to console + window.dataLayer + Meta Pixel
// if these are present. Designed to be wired-up with GA4/GTM/Meta later without code changes.

const EVENT_MAP = {
  view_space:        { ga4: "view_item",        meta: "ViewContent" },
  select_slot:       { ga4: "select_item",      meta: "AddToCart" },
  quote_generated:   { ga4: "view_promotion",   meta: "AddToCart" },
  begin_checkout:    { ga4: "begin_checkout",   meta: "InitiateCheckout" },
  payment_started:   { ga4: "add_payment_info", meta: "AddPaymentInfo" },
  payment_succeeded: { ga4: "purchase",         meta: "Purchase" },
  reservation_confirmed: { ga4: "purchase",     meta: "Purchase" },
};

export function track(eventName, payload = {}) {
  const map = EVENT_MAP[eventName] || {};
  // Always log so we can audit in DevTools
  if (typeof console !== "undefined") {
    console.debug("[track]", eventName, payload);
  }
  // GA4 / GTM
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
    if (map.ga4 && typeof window.gtag === "function") {
      try { window.gtag("event", map.ga4, payload); } catch { /* noop */ }
    }
    // Meta Pixel
    if (map.meta && typeof window.fbq === "function") {
      try { window.fbq("track", map.meta, payload); } catch { /* noop */ }
    }
  }
}
